import { render, staticRenderFns } from "./FeatureCardJoins.vue?vue&type=template&id=b8975cf4&"
import script from "./FeatureCardJoins.vue?vue&type=script&lang=js&"
export * from "./FeatureCardJoins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports